import { ofType } from "redux-observable";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionBaseInfo } from "../../info/base/actionBaseInfo";
import { checkTutorialConstructConfirm } from "../checks/checkTutorialConstructConfirm";
import { checkTutorialNextStepConfigExists } from "../checks/checkTutorialNextStepConfigExists";
import { pathTutorialUpdateViewport } from "../path/pathTutorialUpdateViewport";
export var epicTutorialConstructConfirm = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBaseInfo.FinishConstruction), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialConstructConfirm])(pathTutorialUpdateViewport),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialConstructConfirm.ts
// module id = 2460
// module chunks = 3